import PropTypes from 'prop-types';
import StudioMockupComposer from './StudioMockupComposer';

const StudioPreviewPanel = ({
  productType,
  productColor,
  previewColorName,
  artwork,
  artworkLayers,
  artworkTransforms,
  selectedArtworkSide,
  onArtworkSideSelect,
  previewColors,
  previewColorTotals,
  onPreviewColorSelect,
}) => {
  const getMockupOption = (side) => ({
    id: `${side}-flat`,
    label: side,
    view: side,
    variant: 'flat',
    plateView: side,
    calibrationId: `${side}-2`,
  });
  const mockupOption = getMockupOption(selectedArtworkSide);

  return (
    <div className="studio-preview-panel has-side-picker" data-testid="studio-preview-panel">
      <div className="studio-preview-thumbs" aria-label="Garment side">
        {['front', 'back'].map((side) => (
          <button
            key={side}
            type="button"
            className={`studio-preview-thumb ${selectedArtworkSide === side ? 'is-active' : ''}`}
            onClick={() => onArtworkSideSelect?.(side)}
          >
            <StudioMockupComposer
              productType={productType}
              productColor={productColor}
              colorName={previewColorName}
              view={side}
              artwork={artwork}
              artworkLayers={artworkLayers}
              artworkTransforms={artworkTransforms}
              mockupVariant="flat"
              mockupOption={getMockupOption(side)}
              usePhotoPlates
              compact
            />
            <span>{side}</span>
          </button>
        ))}
      </div>
      <section
        className="studio-preview-garment"
        data-testid={`studio-preview-${selectedArtworkSide}`}
      >
        <StudioMockupComposer
          productType={productType}
          productColor={productColor}
          colorName={previewColorName}
          view={selectedArtworkSide}
          artwork={artwork}
          artworkLayers={artworkLayers}
          artworkTransforms={artworkTransforms}
          mockupVariant="flat"
          mockupOption={mockupOption}
          usePhotoPlates
        />
      </section>
      <div className="studio-preview-colours" aria-label={`${selectedArtworkSide} colours`}>
        {previewColors.map((colorName) => (
          <button
            key={colorName}
            type="button"
            className={`studio-preview-colour-thumb ${previewColorName === colorName ? 'is-active' : ''}`}
            onClick={() => onPreviewColorSelect?.(colorName)}
          >
            <StudioMockupComposer
              productType={productType}
              productColor={productColor}
              colorName={colorName}
              view={selectedArtworkSide}
              artwork={artwork}
              artworkLayers={artworkLayers}
              artworkTransforms={artworkTransforms}
              mockupVariant="flat"
              mockupOption={mockupOption}
              usePhotoPlates
              compact
            />
            <span className="studio-preview-colour-count" aria-label={`${previewColorTotals[colorName] || 0} ${colorName} garments`}>
              {previewColorTotals[colorName] || 0}
            </span>
            <span>{colorName}</span>
          </button>
        ))}
      </div>
    </div>
  );
};

StudioPreviewPanel.propTypes = {
  productType: PropTypes.string.isRequired,
  productColor: PropTypes.string.isRequired,
  previewColorName: PropTypes.string.isRequired,
  artwork: PropTypes.object.isRequired,
  artworkLayers: PropTypes.object,
  artworkTransforms: PropTypes.object.isRequired,
  selectedArtworkSide: PropTypes.oneOf(['front', 'back']).isRequired,
  onArtworkSideSelect: PropTypes.func,
  previewColors: PropTypes.arrayOf(PropTypes.string).isRequired,
  previewColorTotals: PropTypes.objectOf(PropTypes.number),
  onPreviewColorSelect: PropTypes.func,
};

StudioPreviewPanel.defaultProps = {
  previewColorTotals: {},
};

export default StudioPreviewPanel;
